module.exports = __webpack_public_path__ + "static/media/payslipMenuActive.e0c7493c.svg";